<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a v-if="!id" class="section" v-on:click="goTo('/local/users')">Usuarios</a>
    <a v-if="id" class="section" v-on:click="goTo('/local/'+id+'/users')">Usuarios</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Nuevo Usuario</a>
  </div>
  <h1 class="ui header"><i class="icon user"></i>
    <div class="content">Nuevo Usuario</div>
  </h1>
  <button v-if="!id" class="ui basic button rightButton" v-on:click="goTo('/local/users')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <button v-if="id" class="ui basic button rightButton" v-on:click="goTo('/local/'+id+'/users')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <div class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <form class="ui form" @submit.prevent="saveUser">
          <h4 class="ui dividing header">Información del usuario</h4>
          <div class="inline field">
            <sui-checkbox label="Activo" toggle v-model="newUser.active" />
          </div>
          <div v-if="role === 'master' || role === 'admin'" class="inline field">
            <sui-checkbox label="Es Admin" toggle v-model="newUser.esAdmin" />
          </div>
          <div class="field">
            <label>Nombre *</label>
            <input type="text" v-model="newUser.name" placeholder="Nombre" required>
          </div>
          <div class="field">
            <label>Teléfono</label>
            <input type="text" v-model="newUser.phone" placeholder="Telefono" required>
          </div>
          <div class="field">
            <label>Email *</label>
            <input type="text" v-model="newUser.email" placeholder="Email" pattern="^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$">
          </div>
          <div class="field">
            <label>* Campos obligatorios</label>
          </div>
          <button class="ui button" type="submit">Guardar</button>
          <div class="ui button eskubian" v-on:click="cancelAction()">Cancelar</div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'localUserAdd',
  props: ['id'],
  data() {
    return {
      newUser: {
        name: null,
        phone: null,
        email: null,
        active: 1,
        esAdmin: null
      },
      role: null,
    }
  },
  created(){
    //let role = JSON.parse(localStorage.admin).role
    this.role = JSON.parse(localStorage.admin).role
    if (this.role !== 'master' && this.role !=='localAdmin') {
      this.goTo('/parcels', 'localParcels');
    }
  },
  methods: {
    saveUser() {
      hapiickApi().post('/v2/locals/users/add', {
        admin_id: JSON.parse(localStorage.admin).id,
        newUserData: this.newUser,
        id: this.id,
      })
      .then(request => this.userSaved(request))
      //.catch((request) => console.log('error save user: ' + request))
      .catch(() => this.$swal({
        type: 'error',
        title: 'Error',
        text: 'Noooo se han podido guardar los datos'
      }))
    },
    goTo(where, id) {
      let elems = document.getElementsByClassName('item')
      for (var i = 0; i < elems.length; i++) {
        elems[i].classList.remove('active');
      }
      this.$router.push(where)
      //document.getElementById(id).classList.add("active") //Si descomento esto sale msg de errorrr, aunue se haya añadido el usuario ok!!!!!!
    },
    updateEditUser(req) {
      let user = JSON.parse(JSON.stringify(req.data.data.user))
      this.selectedUser = user.CorporationsUser
    },
    userSaved(req) {
      let msg='';
      if (req.data.status !== 'OK') {
        if (req.data.status === 'KO') {
          msg = req.data.message;
        } else {
          msg = 'No se han podido guardar los datos';
        }
        this.$swal({
          type: 'error',
          title: 'Error',
          text: msg
        })
      } else {
        this.$swal({
          type: 'success',
          title: 'Los datos se han guardado correctamente',
          showConfirmButton: false,
          timer: 2500
        })
        this.selectedUser = null

        this.redirectAction();
      }
    },
    cancelAction() {
      this.redirectAction();
    },
    redirectAction() {
      if(this.role === 'master' || this.role === 'admin'){
        this.goTo('/local/'+this.id+'/users', 'localUsers')
      } else {
        this.goTo('/local/users', 'localUsers')
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Local/localUserAdd.vue